// src/pages/Dashboard.js

import React, { useEffect, useState } from "react";
import { apiFetch } from "../api";

export default function Dashboard() {
  const [stats, setStats] = useState({ projects:0, jobs:0, applications:0, contributions:0 });

  useEffect(()=> {
    (async ()=>{
      const p = await apiFetch("projects");
      const j = await apiFetch("jobs");
      const a = await apiFetch("workwithus"); // your workwithus route returns applications
      const c = await apiFetch("contribute"); // if you have listing; otherwise hits contributions.json route
      setStats({
        projects: (p.lists||[]).length || 0,
        jobs: (j.lists||[]).length || 0,
        applications: (a.applications||[]).length || 0,
        contributions: (c.contributions||[]).length || 0,
      });
    })();
  },[]);



  return (
    <div className="page">
      <h2>Dashboard</h2>

      <div className="cards">
        <div className="card">Projects<br/><strong>{stats.projects}</strong></div>

        <div className="card">
          Contributions<br/><strong>{stats.contributions}</strong></div>
          <div className="card">Jobs<br/><strong>{stats.jobs}</strong></div>
      </div>

       <div className="cards">
        <div className="card">Applications<br/><strong>{stats.applications}</strong></div>

        <div className="card">Campaigns<br/><strong>{stats.contributions}</strong></div>

        <div className="card">Promotions<br/><strong>{stats.contributions}</strong></div>

      </div>

    </div>
  );
}
